import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme
} from "@mui/material";
import { LogOut } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { icons } from "../../assets";
import { ADMIN_ROUTES, GENERAL_ROUTES } from "../../routes";
import useUserStore from "../../zustand/useUserStore";
const drawerWidth = 280;

const Sidebar = ({ open, setOpen }) => {
  const { clearUserData } = useUserStore();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRoutes = ADMIN_ROUTES;
  const generalRoutes = GENERAL_ROUTES;
  const theme = useTheme();

  const handleLogout = () => {
    clearUserData();
    navigate("/login");
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? drawerWidth : 120,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: open ? drawerWidth : 120,
          background: "#ffff",
          boxSizing: "border-box",
          transition: "width 0.3s ease",
          overflowX: "hidden",
          boxShadow: "0",
          padding: "20px 2px 20px 20px",
          borderRight: "1px solid #ffff",
        },
      }}
    >
      <Box
        sx={{
          overflow: "auto",
          px: open ? "8px" : "8px",
          backgroundColor: "#eee",
          height: "100%",
          borderRadius: "22px",
        }}
      >
        <Box
          sx={{
            p: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <img
              src={icons.applogo}
              alt="logo"
              style={{
                width: open ? "102px" : "80px",
                height: open ? "70px" : "50px",
              }}
            />
          </Box>
        </Box>

        <Typography
          color="primary.light"
          textAlign={open ? "start" : "cneter"}
          fontSize={12}
          ml={2}
        >
          MENU
        </Typography>

        <List>
          {mainRoutes.map((item) => {
            if (item.isHideMenu) return null;

            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <ListItem
                button
                key={item.id}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  // background: isActive
                  //   ? "linear-gradient(to left, #1367B4, #1880DF, #2394FB, #94CCFF)"
                  //   : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    transform: "translateX(5px)",
                    transition: "transform 0.2s ease",
                  },
                  // border: `1px solid ${isActive ? "transparent" : "#1880DF"}`,
                  justifyContent: open ? "flex-start" : "center",
                  mr: "10px",
                  // my: 0.5,
                  borderRadius: "10px",
                  transition: "all 0.2s ease",
                  padding: "2px 20px",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: open ? 30 : "auto",
                    color: isActive ? "primary.main" : "inherit",
                  }}
                >
                  <Icon
                    size={open ? 20 : 26}
                    color={isActive ? "#225B27" : "#9e9e9e"}
                    strokeWidth={2.5}
                  />
                </ListItemIcon>

                {open && (
                  <ListItemText
                    primary={item.name}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "13px",
                        fontWeight: isActive ? 600 : 400,
                        color: isActive ? "primary.main" : "primary.light",
                      },
                    }}
                  />
                )}
              </ListItem>
            );
          })}
        </List>

        <Typography
          color="primary.light"
          textAlign={open ? "start" : "cneter"}
          fontSize={12}
          ml={2}
          mt={3}
        >
          GENERAL
        </Typography>

        <List>
          {generalRoutes.map((item) => {
            if (item.isHideMenu) return null;

            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <ListItem
                button
                key={item.id}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  // background: isActive
                  //   ? "linear-gradient(to left, #1367B4, #1880DF, #2394FB, #94CCFF)"
                  //   : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    transform: "translateX(5px)",
                    transition: "transform 0.2s ease",
                  },
                  // border: `1px solid ${isActive ? "transparent" : "#1880DF"}`,
                  justifyContent: open ? "flex-start" : "center",
                  mr: "10px",
                  // my: 0.5,
                  borderRadius: "10px",
                  transition: "all 0.2s ease",
                  padding: "2px 20px",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: open ? 30 : "auto",
                    color: isActive ? "primary.main" : "inherit",
                  }}
                >
                  <Icon
                    size={open ? 20 : 26}
                    color={isActive ? "#225B27" : "#9e9e9e"}
                    strokeWidth={2.5}
                  />
                </ListItemIcon>

                {open && (
                  <ListItemText
                    primary={item.name}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "13px",
                        fontWeight: isActive ? 600 : 400,
                        color: isActive ? "primary.main" : "primary.light",
                      },
                    }}
                  />
                )}
              </ListItem>
            );
          })}

          <ListItem
            button
            onClick={handleLogout}
            sx={{
              cursor: "pointer",
              // background: isActive
              //   ? "linear-gradient(to left, #1367B4, #1880DF, #2394FB, #94CCFF)"
              //   : "transparent",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                transform: "translateX(5px)",
                transition: "transform 0.2s ease",
              },
              // border: `1px solid ${isActive ? "transparent" : "#1880DF"}`,
              justifyContent: open ? "flex-start" : "center",
              mr: "10px",
              // my: 0.5,
              borderRadius: "10px",
              transition: "all 0.2s ease",
              padding: "2px 20px",
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: open ? 30 : "auto",
                // color: isActive ? "primary.main" : "inherit",
              }}
            >
              <LogOut
                size={open ? 20 : 26}
                color={"#9e9e9e"}
                strokeWidth={2.5}
              />
            </ListItemIcon>

            {open && (
              <ListItemText
                primary={"Logout"}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "13px",
                    // fontWeight: isActive ? 600 : 400,
                    // color: isActive ? "primary.main" : "primary.light",
                  },
                }}
              />
            )}
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
export { drawerWidth };

